import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license-pro";

import { DesktopRouter } from "./react/legacy/DesktopRouter";

/**
 * Installing MUI X license key (version `Pro`)
 * @see https://mui.com/x/introduction/licensing/#how-to-install-the-key
 */
LicenseInfo.setLicenseKey(
  "589e5d96ed099bc3ae046df37cf2d74cTz0xMjI5MjksRT0xNzk2ODYwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

// initialize react
const root = createRoot(getElementByIdOrThrow("react-app"));
root.render(<DesktopRouter />);

function getElementByIdOrThrow(id: string) {
  const result = document.getElementById(id);
  if (!result) {
    throw new Error(`Element #${id} not found`);
  }
  return result;
}
